import React from 'react';
import {FormattedMessage} from 'react-intl';
import {usePopupEditTotalPaymentContext} from './PopupEditTotalPaymentContext';
import {formatStringToFloatNumber} from '../../../_common/utils/changeInputValue';
import {StyledFieldInput} from '../../../_common/components/FieldInput';
import ModalContent from '../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ButtonAction from '../../../_common/components/ButtonAction';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupEditTotalPaymentForm = () => {
  const {formik, handleEdit, handleCloseModal} = usePopupEditTotalPaymentContext();

  return (
    <>
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldInput
          fieldId={'totalPayment'}
          value={formik.values.totalPayment}
          onChange={(e) => formik.setFieldValue('totalPayment', formatStringToFloatNumber(e))}
          label={<FormattedMessage id="orders-page-column-totalPayment" defaultMessage="Total paid"/>}
        />
      </ModalContent>
      <ModalButtonsContainer customClassnames={largeButtonsPadding}>
        <ButtonAction
          variant={'cancel'}
          onClick={handleCloseModal}
          label={<FormattedMessage id="button-cancel" defaultMessage="Cancel"/>}
          customClassnames={buttonCancel}
        />
        <ButtonAction
          onClick={handleEdit}
          disabled={!formik.dirty}
          useIcon={'/media/common/Check-in-circle_white.svg'}
          label={<FormattedMessage id="button-submit" defaultMessage="Edit"/>}
          customClassnames={buttonSubmit}
        />
      </ModalButtonsContainer>
    </>
  );
};

export default PopupEditTotalPaymentForm;